// extracted by mini-css-extract-plugin
module.exports = {"GoogleButton":"GoogleButton-1-PZ1","Icon":"Icon-2ImJX","Children":"Children-3T_hN","Loading":"Loading-17put"};